import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/contract/setting/warning/list', Object.assign({}, options, {params}));


  export const getInitList = (params, options) =>
    request.get('/api/v4ward/contract/setting/warning/init', Object.assign({}, options, {params}));
  


// 获取列表
export const getProjectList = (params, options) =>
    request.get('/api/v4ward/project/getProjectList', Object.assign({}, options, { params }));

export const updateRow = (params, options) =>
  request.post('/api/v4ward/contract/setting/warning/update', params, options);

// 字典
export const getDictionary = (params, options) =>
request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }))
  

// 字典
export const getProjectUserList = (params, options) =>
request.get('/api/v4ward/user/project-user-list', Object.assign({}, options, { params }))
